import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { CurrencyInput, InputLabeledContainer, TextInput } from 'tennders-common/form/components'

const PaymentDetails = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    disabled = false
  } = props

  return (
    <>
      <h4 className="bold">{t('document:paymentDetails')}</h4>
      <div className="d-flex">
        <InputLabeledContainer
          name="price"
          label={t('document:agreed_price_for_carrying')}
          className="mr-16"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          disabled={disabled}
          renderInput={(rest) => <CurrencyInput {...rest} />}
        />
        <InputLabeledContainer
          name="paymentTerm"
          label={t('document:paymentTerms')}
          form={form}
          errors={errors}
          onChange={onChange}
          required
          disabled={disabled}
          renderInput={(rest) => <TextInput {...rest} />}
        />
      </div>
    </>
  )
}

export default React.memo(PaymentDetails)
